import { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";

const BG_URL =
  "https://customer-assets.emergentagent.com/job_chape-traditionnelle/artifacts/j5d15o66_Designer.png";

const EURO = "EURO";
const CHAPE = "CHAPE";
const STEP = 0.13; // seconds between letters

if (typeof window !== "undefined") {
  const preload = new Image();
  preload.src = BG_URL;
}

export default function Splash() {
  const [show, setShow] = useState(true);

  useEffect(() => {
    document.body.style.overflow = "hidden";
    const t = setTimeout(() => {
      setShow(false);
      document.body.style.overflow = "";
    }, 2800);
    return () => {
      clearTimeout(t);
      document.body.style.overflow = "";
    };
  }, []);

  // Time when typing finishes
  const typedFor = (EURO.length + CHAPE.length) * STEP; // ~1.17s
  const startDelay = 0.3;

  const Letter = ({ char, color, delay }) => (
    <motion.span
      initial={{ opacity: 0, y: 20, scale: 0.6, filter: "blur(6px)" }}
      animate={{ opacity: 1, y: 0, scale: 1, filter: "blur(0px)" }}
      transition={{ duration: 0.32, delay, ease: [0.22, 1, 0.36, 1] }}
      className={`inline-block ${color}`}
    >
      {char}
    </motion.span>
  );

  return (
    <AnimatePresence>
      {show && (
        <motion.div
          key="splash"
          initial={{ opacity: 1 }}
          exit={{ opacity: 0, transition: { duration: 0.7, ease: "easeInOut" } }}
          className="fixed inset-0 z-[200] overflow-hidden"
          style={{
            background:
              "radial-gradient(ellipse at center, #8197B4 0%, #5E7393 45%, #3F5478 80%, #2D4366 100%)",
          }}
          data-testid="splash-screen"
        >
          {/* subtle noise / vignette for depth */}
          <div
            className="absolute inset-0 pointer-events-none"
            style={{
              background:
                "radial-gradient(ellipse at center, transparent 50%, rgba(20,35,72,0.35) 100%)",
            }}
          />

          {/* Centered typewriter logo */}
          <div className="absolute inset-0 flex flex-col items-center justify-center text-center px-6">
            <div
              className="font-display font-black uppercase leading-[0.85] tracking-tight whitespace-nowrap"
              aria-label="Euro Chape"
            >
              <span className="inline-flex items-center text-5xl sm:text-7xl lg:text-[8rem]">
                {EURO.split("").map((ch, i) => (
                  <Letter
                    key={`e-${i}`}
                    char={ch}
                    color="text-[#1A2D7E]"
                    delay={startDelay + i * STEP}
                  />
                ))}
                <span className="inline-block w-[0.35em]" />
                {CHAPE.split("").map((ch, i) => (
                  <Letter
                    key={`c-${i}`}
                    char={ch}
                    color="text-[#F08722]"
                    delay={startDelay + (EURO.length + i) * STEP}
                  />
                ))}
              </span>
            </div>

            {/* Drawn underline */}
            <motion.div
              initial={{ scaleX: 0 }}
              animate={{ scaleX: 1 }}
              transition={{
                duration: 1,
                delay: startDelay + typedFor + 0.2,
                ease: [0.86, 0, 0.07, 1],
              }}
              className="origin-left h-[3px] mt-6 bg-[#F08722] w-[clamp(180px,40vw,360px)] shadow-[0_2px_12px_rgba(240,135,34,0.55)]"
            />

            {/* Tagline appears after writing */}
            <motion.div
              initial={{ opacity: 0, y: 8 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{
                duration: 0.5,
                delay: startDelay + typedFor + 0.9,
              }}
              className="mt-5 text-xs sm:text-sm uppercase tracking-[0.32em] text-[#1A2D7E] font-semibold"
            >
              Chape · Béton · Isolation
            </motion.div>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
